import PropTypes from 'prop-types';
import BaseSelectorReadonlyToInput from "../../component/Select/BaseSelectorReadonlyToInput";
import ReadpointService from "../../services/ReadpointService";

class ReadpointSelector extends BaseSelectorReadonlyToInput {

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      title: 'Ponto de Leitura',
      label: 'friendlyName',
      value: 'id',
      url: ReadpointService.ALL_URL
    };
  }
}

ReadpointSelector.propTypes = {
  required: PropTypes.bool,
  setValue: PropTypes.func,
  defaultValue: PropTypes.string,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ReadpointSelector;



// WEBPACK FOOTER //
// ./src/readpoint/component/ReadpointSelector.js